import PropTypes from 'prop-types';
import { useEffect } from 'react';
function NewRelicPageActionTrigger(props) {
  const {
    name
  } = props;
  useEffect(() => {
    if (name) {
      if (window.newrelic) {
        window.newrelic.addPageAction(name, {
          currentTime: performance.now()
        });
      }
    }
  }, [name]);
  return null;
}
NewRelicPageActionTrigger.propTypes = {
  name: PropTypes.string.isRequired
};
export default NewRelicPageActionTrigger;